export function simpleDeepCopy(sourceObj) {
  return JSON.parse(JSON.stringify(sourceObj));
}
